<template>
  <LoginBox />
</template>

<script>
import LoginBox from "../components/LoginBox.vue"
export default {
    name:"LoginPage",
    components: {
      LoginBox
    }
}
</script>

<style>

</style>